import React from "react";
import styles from "./UserFooter.module.css";

const UserFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <p className={styles.footerText}>
          Copyright © {currentYear} All rights reserved. A product of{" "}
          <a
            href="https://bharatclouds.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.footerLink}
          >
            Bharat Clouds Pvt Ltd
          </a>
        </p>
      </div>
    </footer>
  );
};

export default UserFooter;
